const base = process.env.PUBLIC_URL || '';

export const typography = {
  fontFamily: {
    heading: ['apercu condensed pro', 'impact'].join(','),
    main: ['apercu pro', 'helvetica', 'verdana', 'sans-serif'].join(','),
    primary: ['apercu pro', 'helvetica', 'verdana', 'sans-serif'].join(','),
    secondary: ['ApercuMonoRegularPro', 'sans-serif'].join(','),
    emphasis: ['bordonaro', 'sans-serif'].join(','),
  },
  fonts: `
    @font-face {
      font-family: 'apercu condensed pro';
      src: url(${base}/fonts/apercu-condensed-bold-pro.woff2) format('woff2'),
           url(${base}/fonts/apercu-condensed-bold-pro.woff) format('woff');
      font-weight: 700;
      font-style: normal;
      font-display: swap;
      size-adjust: 100%;
    }
    @font-face {
      font-family: 'apercu condensed pro';
      src: url(${base}/fonts/apercu-condensed-medium-pro.woff2) format('woff2'),
           url(${base}/fonts/apercu-condensed-medium-pro.woff) format('woff');
      font-weight: 600;
      font-style: normal;
      font-display: optional;
      size-adjust: 100%;
    }

    @font-face {
      font-family: 'apercu pro';
      src: url(${base}/fonts/apercu-regular-pro.woff2) format('woff2'),
           url(${base}/fonts/apercu-regular-pro.woff) format('woff');
      font-weight: 400;
      font-style: normal;
      font-display: swap;
      size-adjust: 100%;
    }

    @font-face {
      font-family: 'apercu pro';
      src: url(${base}/fonts/apercu-medium-pro.woff2) format('woff2'),
           url(${base}/fonts/apercu-medium-pro.woff) format('woff');
      font-weight: 500;
      font-style: normal;
      font-display: optional;
      size-adjust: 100%;
    }

    @font-face {
      font-family: 'apercu pro';
      src: url(${base}/fonts/apercu-bold-pro.woff2) format('woff2'),
           url(${base}/fonts/apercu-bold-pro.woff) format('woff');
      font-weight: 600;
      font-style: normal;
      font-display: swap;
      size-adjust: 100%;
    }

    @font-face {
      font-family: 'bordonaro';
      src: url(${base}/fonts/bordonaro.woff2) format('woff2'),
           url(${base}/fonts/bordonaro.woff) format('woff');
      font-weight: 600;
      font-style: normal;
      font-display: optional;
      size-adjust: 100%;
    }

    @font-face {
      font-family: 'chunk';
      src: url(${base}/fonts/Chunk-Black.woff2) format('woff2'),
           url(${base}/fonts/Chunk-Black.woff) format('woff');
      font-weight: 900;
      font-style: normal;
      font-display: optional;
      size-adjust: 100%;
    }
    @font-face {
      font-family: 'hello headline';
      src: url(${base}/fonts/HelloHeadlineW00-Regular.woff2) format('woff2'),
           url(${base}/fonts/HelloHeadlineW00-Regular.woff) format('woff');
      font-weight: 400;
      font-style: normal;
      font-display: optional;
      size-adjust: 100%;
    }
  `,
};